import React from "react";
import { get } from "lodash";
import Chip from "@/shared/ui/Chip";

interface CustomColumn {
  title: string;
  type: string;
  data_key: string;
  span?: number;
  searchable?: boolean;
}

type CustomColumns = {
  [key: string]: CustomColumn;
};

interface EntityWithMetadata {
  [key: string]: any;
  meta?: {
    [key: string]: any;
  };
}

const rraStatuses = {
  1: {
    title: "New",
    color: "orange",
  },
  10: {
    title: "Awaiting AM to Complete",
    color: "grey",
  },
  4: {
    title: "Open",
    color: "orange",
  },
  19: {
    title: "New",
    color: "orange",
  },
  13: {
    title: "Reopened",
    color: "orange",
  },
  16: {
    title: "Never Start",
    color: "grey",
  },
  2: {
    title: "Awaiting Approval",
    color: "grey",
  },
  14: {
    title: "Resolved",
    color: "green",
  },
  8: {
    title: "Completed",
    color: "green",
  },
  15: {
    title: "Cancelled",
    color: "grey",
  },
};

function RraProjectStatus(status: number) {
  const statusData = rraStatuses[status as keyof typeof rraStatuses];

  if (!statusData) return null;

  return <Chip color={statusData.color as any}>{statusData.title}</Chip>;
}

export const parseCustomColumn = (type: string, value: any) => {
  switch (type) {
    case "rra_project_status":
      return RraProjectStatus(value);
    default:
      return value;
  }
};

export const searchCustomColumns = (
  columns: CustomColumns,
  value: EntityWithMetadata,
  searchKey: string
) => {
  if (!columns || Object.keys(columns).length === 0) return false;

  const searchableColumns = Object.values(columns).filter(
    (column) => column.searchable || column.type === "text"
  );

  return searchableColumns.some((column) => {
    const searchedValue = get(value, column.data_key);
    return searchedValue?.toLowerCase().includes(searchKey?.toLowerCase());
  });
};
